<template>
    <sequential-entrance fromBottom>
  <v-card class="video-card-1" style="padding: 0px; align: width: 100%">
  <youtube class="video-card-1" :video-id="videoId" width="1920" height="1100" margin="0" padding="0" :player-vars="playerVars" @playing="playing"></youtube>

	</v-card>
  </sequential-entrance>
</template>

<script>

export default {
  data() {
    return {
      media: null,
      videoId: 'C4MpzSMkinw',
      playerVars: {
        autoplay: 1
      }
    }
  },
  components: {

  },
  methods: {
    playing() {
      console.log('We are watching!!!')
    }
  }
}
</script>



<style>
.video-card-1 {
 background: rgba(48, 64, 87, 0.1);
 outline-color: rgba(90, 128, 191, 0.3);
 outline-style: solid;
 border-color: #5a80bf;
 box-shadow: 0 0 5px rgba(90,128,191,.4), inset 0 0 0px rgba(90,128,191,.2), 0 0px 0 #000;
 color: #efe;
 outline-width: 2px;
 height: 1100px;
 width: 2000px;
 padding: 10px;
}
</style>
